export const dataHubData = {
  Romania: [
    {
      name: 'National Institute of Statistics',
      description: 'Institutul Național de Statistică',
      countryRegion: 'Romania',
      topic: 'Circular economy',
      website: 'https://insse.ro/cms/ro/content/statistica-mediului'
    },
    {
      name: 'National Institute of Statistics',
      description: 'Institutul Național de Statistică',
      countryRegion: 'Romania',
      topic: 'Digital transition',
      website: 'https://insse.ro/cms/ro/content/tehnologia-informației-și-comunicațiilor'
    },
    {
      name: 'Ministry of Investments and European Projects',
      description: 'Ministerul Investițiilor și Proiectelor Europene',
      countryRegion: 'Romania',
      topic: 'Smart specialization strategy (S3)',
      website: 'https://mfe.gov.ro/specializare-inteligenta/'
    },
    {
      name: 'National Institute of Statistics',
      description: 'Institutul Național de Statistică',
      countryRegion: 'Romania',
      topic: 'Other relevant economic data',
      website: 'https://insse.ro/cms/ro'
    }
  ],
  Serbia: [
    {
      name: 'Statistical Office of the Republic of Serbia',
      description: 'Republički zavod za statistiku',
      countryRegion: 'Serbia',
      topic: 'Other relevant economic data',
      website: 'https://www.stat.gov.rs/en-us/?utm_source=chatgpt.com'
    },
    {
      name: 'Statistical Office of the Republic of Serbia – Innovation statistics',
      description: 'Republički zavod za statistiku',
      countryRegion: 'Serbia',
      topic: 'Digital transition',
      website: 'https://www.stat.gov.rs/en-us/oblasti/nauka-tehnologija-i-inovacije/inovacije/?utm_source=chatgpt.com'
    },
    {
      name: 'Open Data Portal Serbia (Open Data Hub)',
      description: 'Portal otvorenih podataka Srbije',
      countryRegion: 'Serbia',
      topic: 'Digital transition',
      website: 'https://data.gov.rs/sr/'
    },
    {
      name: 'National Bank of Serbia',
      description: 'Narodna banka Srbije',
      countryRegion: 'Serbia',
      topic: 'Other relevant economic data',
      website: 'https://www.nbs.rs/en'
    },
    {
      name: 'National Employment Service',
      description: 'Nacionalna služba za zapošljavanje',
      countryRegion: 'Serbia',
      topic: 'Other relevant economic data',
      website: 'https://www.nsz.gov.rs'
    },
    {
      name: 'Serbian Environmental Protection Agency',
      description: 'Agencija za zaštitu životne sredine',
      countryRegion: 'Serbia',
      topic: 'Circular economy',
      website: ''
    },
    {
      name: 'Ministry of Agriculture, Forestry and Water Management',
      description: 'Ministarstvo poljoprivrede, šumarstva i vodoprivrede',
      countryRegion: 'Serbia',
      topic: 'Circular economy',
      website: 'https://www.minpolj.gov.rs/'
    }
  ],
  Moldova: [
    {
      name: 'National Bureau of Statistics of the Republic of Moldova',
      description: 'Biroul Național de Statistică',
      countryRegion: 'Moldova',
      topic: 'Other relevant economic data',
      website: 'https://statistica.gov.md/ro/'
    },
    {
      name: 'Statistical Databank “Statbank” (BNS)',
      description: 'Banca de date „Statbank” (BNS)',
      countryRegion: 'Moldova',
      topic: 'Other relevant economic data',
      website: 'http://statbank.statistica.md/'
    },
    {
      name: 'Republic of Moldova Open Data Portal',
      description: 'Portale de date deschise (inclusiv digital/statistici divers)',
      countryRegion: 'Moldova',
      topic: 'Digital transition',
      website: 'https://dataset.gov.md/en/stats?utm'
    }
  ],
  Germany: [
    {
      name: 'Federal Statistical Office of Germany',
      description: 'Statistisches Bundesamt (Destatis)',
      countryRegion: 'Germany',
      topic: 'Circular economy',
      website: 'https://www.destatis.de/EN/Themes/Society-Environment/Environment/Waste-Management/_node.html'
    },
    {
      name: 'Federal Statistical Office of Germany',
      description: 'Statistisches Bundesamt (Destatis)',
      countryRegion: 'Germany',
      topic: 'Other relevant economic data',
      website: 'https://www.destatis.de/EN/Themes/Society-Environment/Environmental-Economic-Accounting/_node.html'
    },
    {
      name: 'German Environment Agency',
      description: 'Umweltbundesamt (UBA)',
      countryRegion: 'Germany',
      topic: 'Circular economy',
      website: 'https://www.umweltbundesamt.de/en/data/environmental-indicators'
    },
    {
      name: 'Statistical Office of Baden-Württemberg',
      description: 'Statistisches Landesamt Baden-Württemberg',
      countryRegion: 'Germany',
      topic: 'Other relevant economic data',
      website: 'https://www.statistik-bw.de/umwelt-und-verkehr/'
    },
    {
      name: 'Baden-Württemberg State Institute for Environment',
      description: 'Landesanstalt für Umwelt Baden-Württemberg (LUBW)',
      countryRegion: 'Germany',
      topic: 'Other relevant economic data',
      website: 'https://www.lubw.baden-wuerttemberg.de/umweltdaten-umweltindikatoren'
    }
  ],
  Croatia: [
    {
      name: 'Croatian Bureau of Statistics',
      description: 'Državni zavod za statistiku',
      countryRegion: 'Croatia',
      topic: 'Circular economy',
      website: 'https://dzs.gov.hr   https://podaci.dzs.hr'
    },
    {
      name: 'Ministry of Economy',
      description: 'Ministarstvo gospodarstva',
      countryRegion: 'Croatia',
      topic: 'Circular economy',
      website: 'https://mingo.gov.hr'
    },
    {
      name: 'Environmental Protection and Energy Efficiency Fund',
      description: 'Fond za zaštitu okoliša i energetsku učinkovitost',
      countryRegion: 'Croatia',
      topic: 'Circular economy',
      website: 'https://www.fzoeu.hr'
    },
    {
      name: 'Croatian Bureau of Statistics',
      description: 'Državni zavod za statistiku',
      countryRegion: 'Croatia',
      topic: 'Digital transition',
      website: 'https://dzs.gov.hr https://podaci.dzs.hr'
    },
    {
      name: 'Ministry of Justice, Public Administration and Digital Transformation',
      description: 'Ministarstvo pravosuđa, uprave i digitalne transformacije',
      countryRegion: 'Croatia',
      topic: 'Digital transition',
      website: 'https://mpudt.gov.hr'
    },
    {
      name: 'Central State Office for the Development of Digital Society',
      description: 'Središnji državni ured za razvoj digitalnog društva',
      countryRegion: 'Croatia',
      topic: 'Digital transition',
      website: 'https://digitalna.hr'
    },
    {
      name: 'Ministry of Science and Education',
      description: 'Ministarstvo znanosti i obrazovanja',
      countryRegion: 'Croatia',
      topic: 'Smart specialization strategy (S3)',
      website: 'https://mzom.gov.hr'
    },
    {
      name: 'Ministry of Economy',
      description: 'Ministarstvo gospodarstva',
      countryRegion: 'Croatia',
      topic: 'Smart specialization strategy (S3)',
      website: 'https://s3.hr/'
    },
    {
      name: 'HAMAG-BICRO',
      description: 'Hrvatska agencija za malo gospodarstvo, inovacije i investicije',
      countryRegion: 'Croatia',
      topic: 'Smart specialization strategy (S3)',
      website: 'https://hamagbicro.hr'
    },
    {
      name: 'Croatian National Bank',
      description: 'Hrvatska narodna banka',
      countryRegion: 'Croatia',
      topic: 'Other relevant economic data',
      website: 'https://www.hnb.hr'
    },
    {
      name: 'Croatian Chamber of Economy',
      description: 'Hrvatska gospodarska komora',
      countryRegion: 'Croatia',
      topic: 'Other relevant economic data',
      website: 'https://www.hgk.hr'
    },
    {
      name: 'Ministry of Finance',
      description: 'Ministarstvo financija',
      countryRegion: 'Croatia',
      topic: 'Other relevant economic data',
      website: 'https://mfin.gov.hr'
    }
  ],
  Bulgaria: [
    {
      name: 'N/A',
      description: 'Н/П',
      countryRegion: 'Bulgaria',
      topic: 'Circular economy',
      website: ''
    },
    {
      name: 'N/A',
      description: 'Н/П',
      countryRegion: 'Bulgaria',
      topic: 'Digital transition',
      website: ''
    },
    {
      name: 'INFORMATION SYSTEM FOR MANAGEMENT AND MONITORING OF EU FUNDS IN BULGARIA',
      description: 'Информационна система за управление и наблюдение на средствата от ЕС в България',
      countryRegion: 'Bulgaria',
      topic: 'Smart specialization strategy (S3)',
      website: 'https://2020.eufunds.bg/'
    },
    {
      name: 'National Statistical Institute of Bulgaria',
      description: 'Национален Статистически Институт',
      countryRegion: 'Bulgaria',
      topic: 'Other relevant economic data',
      website: 'https://www.nsi.bg/en'
    }
  ],
  Slovenia: [
    {
      name: 'Statistical Office of the Republic of Slovenia',
      description: 'Statistični urad Republike Slovenije (SURS)',
      countryRegion: 'Slovenia',
      topic: 'Circular economy',
      website:
        'SiStat – Environment & Circular Economy datasets: https://pxweb.stat.si/sistat/en (Environmental indicators include waste, material flows, resource efficiency).'
    },
    {
      name: 'Statistical Office of the Republic of Slovenia',
      description: 'Statistični urad Republike Slovenije (SURS)',
      countryRegion: 'Slovenia',
      topic: 'Digital transition',
      website:
        'SiStat – Development & technology, ICT usage, digital indicators: https://pxweb.stat.si/sistat/en [gov.si]'
    },
    {
      name: 'Statistical Office of the Republic of Slovenia',
      description: 'Statistični urad Republike Slovenije (SURS)',
      countryRegion: 'Slovenia',
      topic: 'Smart specialization strategy (S3)',
      website:
        'SiStat – Enterprises, Innovation, Productivity data: https://pxweb.stat.si/sistat/en (supports S3 monitoring through innovation, enterprise structure, high‑tech indicators).'
    },
    {
      name: 'Statistical Office of the Republic of Slovenia',
      description: 'economic dataStatistični urad Republike Slovenije (SURS)',
      countryRegion: 'Slovenia',
      topic: 'Other relevant economic data',
      website:
        'SiStat main economic categories: GDP, labour market, prices, earnings, trade: https://pxweb.stat.si/sistat/en and https://www.stat.si/StatWeb/en/home'
    }
  ],
  Czechia: [
    {
      name: 'Czech Statistical Office (CZSO)',
      description: 'Český statistický úřad',
      countryRegion: 'Czechia',
      topic: 'Circular economy',
      website: 'https://csu.gov.cz/environmental-accounts?pocet=10&start=0&podskupiny=286&razeni=-datumVydani'
    },
    {
      name: 'Czech Statistical Office (CZSO)',
      description: 'Český statistický úřad',
      countryRegion: 'Czechia',
      topic: 'Digital transition',
      website: 'https://csu.gov.cz/digital-economy'
    },
    {
      name: 'Czech Statistical Office (CZSO)',
      description: 'Český statistický úřad',
      countryRegion: 'Czechia',
      topic: 'Smart specialization strategy (S3)',
      website:
        'https://csu.gov.cz/innovation?pocet=10&start=0&podskupiny=061&datumVydani=dvPredchozich5Let&razeni=-datumVydani'
    },
    {
      name: "Government/'s open data",
      description: 'Portál o datech',
      countryRegion: 'Czechia',
      topic: 'Other relevant economic data',
      website: 'https://data.gov.cz/'
    }
  ],
  Slovakia: [
    {
      name: 'Statistical Office of the Slovak Republic',
      description: 'Štatistický úrad Slovenskej republiky',
      countryRegion: 'Slovakia',
      topic: '',
      website:
        'DATA.cube: https://datacube.statistics.sk/#!/lang/en/?utm_source=susr_portalHP&utm_medium=page_database&utm_campaign=DATAcube_portalHP STATdata: https://statdata.statistics.sk/public/ui/dc/domov/data-view'
    },
    {
      name: 'Enviroportal',
      description: 'Enviroportál',
      countryRegion: 'Slovakia',
      topic: 'Circular economy',
      website: 'https://www.enviroportal.sk/en/indicators'
    }
  ],
  'Bosnia and Herzegovina': [
    {
      name: 'Agency for Statistics of Bosnia and Herzegovina (BHAS)',
      description: 'Agencija za statistiku Bosne i Hercegovine All relevant stats topics',
      countryRegion: 'Bosnia and Herzegovina',
      topic: 'Other relevant economic data',
      website: 'https://bhas.gov.ba'
    },
    {
      name: 'Federal Office of Statistics (FBiH)',
      description: 'Federalni zavod za statistiku All relevant stats topics',
      countryRegion: 'Bosnia and Herzegovina',
      topic: 'Other relevant economic data',
      website: 'https://fzs.ba'
    },
    {
      name: 'Institute of Statistics of Republika Srpska',
      description: 'Republički zavod za statistiku Republike Srpske All relevant stats topics',
      countryRegion: 'Bosnia and Herzegovina',
      topic: 'Other relevant economic data',
      website: 'https://www.rzs.rs.ba'
    }
  ],
  Austria: [
    {
      name: 'ICT usage in companies in 2025',
      description: 'IKT-Einsatz in Unternehmen 2025',
      countryRegion: 'Austria',
      topic: 'Digital transition',
      website: '2025-36-ikt-2025.pdf'
    },
    {
      name: 'Circular economy country profile 2024 - Austria',
      description: 'Kreislaufwirtschaftsprofil Österreich 2024',
      countryRegion: 'Austria',
      topic: 'Circular economy',
      website:
        'https://www.eea.europa.eu/en/topics/in-depth/circular-economy/country-profiles-on-circular-economy/circular-economy-country-profiles-2024/austria_2024-ce-country-profile_final.pdf/@@download/file'
    },
    {
      name: 'Digital transformation in Austrian companies in 2025',
      description: 'Digitaler Wandel in österreichischen Unternehmen 2025',
      countryRegion: 'Austria',
      topic: 'Digital transition',
      website: 'EY Studie Digitaler Wandel in österreichischen Unternehmen 2025 | EY - Österreich'
    },
    {
      name:
        'The Austrian Circular Economy Strategy Austria on the path to a sustainable and circular society – First progress report June 2024',
      description:
        'Die österreichische Kreislaufwirtschaftsstrategie Österreich auf dem Weg zu einer nachhaltigen und zirkulären Gesellschaft – Erster Fortschrittsbericht Juni 2024',
      countryRegion: 'Austria',
      topic: 'Circular economy',
      website:
        'Die österreichische Kreislaufwirtschaftsstrategie Österreich auf dem Weg zu einer nachhaltigen und zirkulären Gesellschaft – Erster Fortschrittsbericht Juni 2024'
    },
    {
      name: 'Material flow calculation',
      description: 'Materialflussrechnung',
      countryRegion: 'Austria',
      topic: 'Circular economy',
      website: 'Materialflussrechnung - STATISTIK AUSTRIA - Die Informationsmanager'
    },
    {
      name: 'Environmentally-oriented production and services',
      description: 'Umweltorientierte Produktion und Dienstleistung',
      countryRegion: 'Austria',
      topic: 'Circular economy',
      website: 'Umweltorientierte Produktion und Dienstleistung - STATISTIK AUSTRIA - Die Informationsmanager'
    },
    {
      name: 'ICT usage in households',
      description: 'Nutzung von IKT in Haushalten',
      countryRegion: 'Austria',
      topic: 'Digital transition',
      website: 'ICT usage in households - STATISTICS AUSTRIA - The Information Manager'
    }
  ],
  Hungary: [
    {
      name: 'Hungarian Central Statistics Office',
      description: 'Központi Statisztikai Hivatal (KSH)',
      countryRegion: 'Hungary',
      topic: 'Other relevant economic data',
      website: 'https://ksh.gov.hu/'
    },
    {
      name: 'KSH – Circular Economy Publication',
      description: 'KSH - Körforgásos gazdaság',
      countryRegion: 'Hungary',
      topic: 'Circular economy',
      website: 'https://www.ksh.hu/s/kiadvanyok/korforgasos-gazdasag/index.html'
    },
    {
      name: 'KSH – Information & Communication',
      description: 'KSH- Információ és kommunikáció',
      countryRegion: 'Hungary',
      topic: 'Digital transition',
      website: 'https://www.ksh.gov.hu/informacio-kommunikacio'
    },
    {
      name: 'National Research, Development and Innovation Office (NRDI Office)',
      description: 'Nemzeti Kutatási, Fejlesztési és Innovációs Hivatal (NKFI Hivatal)',
      countryRegion: 'Hungary',
      topic: 'Smart specialization strategy (S3)',
      website: 'https://nkfih.gov.hu/hivatalrol/nemzeti-intelligens/nemzeti-intelligens-szakosodasi-strategia-2021-2027'
    }
  ]
}
